class ChocoConfig {
    static lang = 'esMX';
}


export default ChocoConfig;